import type { AsyncBelongsTo } from '@ember-data/model';
import Component from '@glimmer/component';
import DeviceModel from 'garaje/models/device';

interface SignInOutDetailsComponentSignature {
  Args: {
    device?: DeviceModel | AsyncBelongsTo<DeviceModel>;
    via: string | null;
    by: string | null;
    type: string;
  };
  Element: HTMLElement;
}

export default class SignInOutDetailsComponent extends Component<SignInOutDetailsComponentSignature> {
  get viaText(): string {
    const via = this.args.via;
    if (!via) return '';

    const device = this.args.device;
    const deviceName = device instanceof DeviceModel ? device.displayName : device?.content?.displayName;
    return via === 'iPad' && deviceName ? `${via}: ${deviceName}` : via;
  }
}
